import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.lightBg};
    border-radius: 33px;
    width: 360px;
    padding: 40px;
    text-align: center;
  `}
`;

export const InfoTextWrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-gap: 20px;
  margin-top: 40px;
`;

export const Title = styled.h2`
  ${({theme}) => css`
    color: ${theme.colors.gray8};
    font-size: 26px;
    font-weight: ${theme.font.weight.normal};
  `}
`;

export const Email = styled.p`
  ${({theme}) => css`
    color: ${theme.colors.gray4};
    font-size: ${theme.font.sizes.xsmall};
    font-weight: ${theme.font.weight.semiBold};
  `}
`;

export const InfoText = styled.p`
  ${({theme}) => css`
    color: ${theme.colors.gray4};
    font-size: ${theme.font.sizes.xsmall};
  `}
`;

export const FooterText = styled.p`
  ${({theme}) => css`
    color: ${theme.colors.gray7};
    font-size: ${theme.font.sizes.xsmall};
    font-weight: ${theme.font.weight.normal};
    white-space: nowrap;
    cursor: auto;

    span {
      color: currentColor;
      font-weight: ${theme.font.weight.bold};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  `}
`;
